import InterviewAccordion from './InterviewAccordion';
import InterviewAccordionItem from './InterviewAccordionItem';

export { InterviewAccordion, InterviewAccordionItem };
export default InterviewAccordion;


// WEBPACK FOOTER //
// ./src/components/Recruiter/InterviewAccordion/index.js